import _classCallCheck from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck';
import _createClass from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass';
import _possibleConstructorReturn from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf';
import _inherits from 'E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module basic-styles/bold/boldui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import boldIcon from '../../theme/icons/bold.svg';
var BOLD = 'bold';
/**
 * The bold UI feature. It introduces the Bold button.
 *
 * @extends module:core/plugin~Plugin
 */
var BoldUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(BoldUI, _Plugin);
    function BoldUI() {
        _classCallCheck(this, BoldUI);
        return _possibleConstructorReturn(this, _getPrototypeOf(BoldUI).apply(this, arguments));
    }
    _createClass(BoldUI, [{
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = editor.t;
                // Add bold button to feature components.
                editor.ui.componentFactory.add(BOLD, function (locale) {
                    var command = editor.commands.get(BOLD);
                    var view = new ButtonView(locale);
                    view.set({
                        label: t('Жирный'),
                        icon: boldIcon,
                        keystroke: 'CTRL+B',
                        tooltip: true,
                        isToggleable: true
                    });
                    view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
                    // Execute command.
                    _this.listenTo(view, 'execute', function () {
                        return editor.execute(BOLD);
                    });
                    return view;
                });
            }
        }]);
    return BoldUI;
}(Plugin);
export {
    BoldUI as default
};